import {
  assoc,
  assocPath,
  curry,
  findIndex,
  insert,
  map,
  path,
  pipe,
  propEq,
  propOr,
  remove,
  when,
  gte,
} from 'ramda';

export const changeItemInStatuses = ({ statuses, currentResource, prefix, answer }) =>
  assocPath(
    ['entry', '0', 'resource', 'item'],
    pipe(
      curry(
        map(
          when(propEq('linkId', prefix), readData =>
            assoc(
              'item',
              pipe(
                propOr([], 'item'),
                items => {
                  const editedIndex = findIndex(propEq('linkId', `${prefix}-${currentResource}`))(
                    items,
                  );
                  return pipe(
                    values => (gte(editedIndex, 0) ? remove(editedIndex, 1, values) : values),
                    insert(editedIndex, {
                      linkId: `${prefix}-${currentResource}`,
                      answer: [answer],
                    }),
                  )(items);
                },
              )(readData),
            )(readData),
          ),
        ),
      ),
    )(path(['entry', '0', 'resource', 'item'])(statuses)),
    statuses,
  );
